export const version = "7.3.7";
export const major = Number("7");
export const minor = Number("3");
export const patch = Number("7");
export const prerelease = undefined;
export default version;